export const CURRENCY_SYMBOL = '₹';

export const IND_RUPEE = '₹';
export const DOLLAR = '$';

export const MARGIN_SEGMENT = {
  National: 'NATIONAL',
  International: 'INTERNATIONAL',
};
